import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  combineLatest,
  filter,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';
import { AuthService } from 'src/app/auth/services/auth.service';
import { CompanyStore } from 'src/app/features/company-profile-data/services/company.store';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<any> = new Subject();
  public isLoggedIn: boolean = false;
  public accountManagers: any = [];
  public userInfo: any;
  constructor(public store: CompanyStore, public auth: AuthService) {}
  ngOnInit(): void {
    this.auth.isLoggedIn$
      .pipe(
        takeUntil(this._destroy$),
        tap((isLoggedIn) => (this.isLoggedIn = isLoggedIn)),
        filter((isLoggedIn) => !!isLoggedIn),
        switchMap((_) => {
          if (this.auth.isMedikoUser)
            return combineLatest([this.store.contacts$, this.auth.user]).pipe(
              takeUntil(this._destroy$),
              tap(([contacts, user]) => {
                this.userInfo = contacts?.workers?.find(
                  (w) => w.userId == user?.id
                );
              })
            );
          else
            return this.store.accountManagers$.pipe(
              takeUntil(this._destroy$),
              tap((accountManagers) => {
                if (accountManagers && accountManagers.length > 0)
                  this.accountManagers = accountManagers;
              })
            );
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this._destroy$.next(undefined);
    this._destroy$.complete();
  }
}
